import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FlatButton from 'material-ui/FlatButton';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import _ from 'lodash';
import { fromJS } from 'immutable';

import AutoComplete from 'material-ui/AutoComplete';

import ReduxDialog from '../Common/ReduxDialog/';
import { hideDialog, showDialog } from '../../actions/dialogs';
import { fetchEmployees } from '../../actions/employees';
import { customizedFuzzyFilter, sortStrings } from '../../utils/helper';
import { getDialogContextProp } from '../../reducers/helper';
import { assignResourcesToTasks } from '../../actions/tasks';
import icons from '../../utils/icons';

import styles from './styles';

const employeeDSConfig = {
  text: 'name',
  value: 'id',
};

class AssignEmployeesToStagesDialog extends React.Component {
  static propTypes = {
    // onRequestClose: PropTypes.func.isRequired,
    job: PropTypes.object.isRequired,
    stages: PropTypes.array,
    employees: PropTypes.array,
    hideDialog: PropTypes.func.isRequired,
    fetchEmployees: PropTypes.func.isRequired,
    assignResourcesToTasks: PropTypes.func.isRequired,
    tasks: PropTypes.array,
  };

  state = {
    stages: {},
  };

  componentWillMount() {
    this.props.fetchEmployees();
  }

  handleSelectEmployee = (stageId, employeeId) => {
    this.setState({
      stages: _.assign({}, this.state.stages, { [stageId]: { assignedTo: employeeId } }),
    });
  };

  handleSave = () => {
    this.props.assignResourcesToTasks(this.props.tasks, this.state.stages);
    this.props.hideDialog('assignEmployeesToStages');
  };

  renderStage(stage) {
    console.log('stage', stage);
    return (<TableRow key={stage.id} displayBorder={false}>
      <TableRowColumn style={styles.stageCol}>
        <img src={icons[stage.icon]} style={styles.stageIcon} alt={stage.name}/> {stage.name}
      </TableRowColumn>
      <TableRowColumn>
        <AutoComplete
          name="employee"
          textFieldStyle={styles.autocomplete}
          dataSource={this.props.employees}
          dataSourceConfig={employeeDSConfig}
          filter={customizedFuzzyFilter}
          hintText="Employee"
          openOnFocus
          onNewRequest={(employee) => this.handleSelectEmployee(stage.id, employee.id)
          }
          fullWidth
        />
      </TableRowColumn>
    </TableRow>);
  }

  renderStages() {
    return (<div>
      <div>
        <Table selectable={false}>
          <TableHeader style={styles.tableHeader} displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow displayBorder={false}>
              <TableHeaderColumn style={styles.stageCol}>Stage</TableHeaderColumn>
              <TableHeaderColumn>Employee</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            { this.props.stages ? this.props.stages.map((stage) => this.renderStage(stage)) : '' }
          </TableBody>
        </Table>
      </div>
    </div>);
  }

  render() {
    const buttons = [<FlatButton
      label="Cancle"
      primary
      onClick={() => this.props.hideDialog('assignEmployeesToStages')}
    />,
      <FlatButton
        label="Save"
        primary
        keyboardFocused
        onClick={() => this.handleSave()}
      />];
    return (
      <ReduxDialog
        name="assignEmployeesToStages"
        title={'Stage Assignment'}
        actions={buttons}
        bodyStyle={styles.body}
      >
        { this.renderStages() }
      </ReduxDialog>
    );
  }
}

function mapStateToProps(state) {
  const job = state.get('jobs').get('job').toJS();
  const resources = _.values(job.resources || {}).filter((resource) => resource.employeeId).map((resource) => resource.employeeId);
  const employees = state.get('employees').get('employees').toJS().filter((employee) => resources.indexOf(employee.id) >= 0).sort((a, b) => sortStrings(a.name, b.name));

  console.log('resources', resources);
  console.log('employees', employees);

  return {
    job,
    stages: getDialogContextProp(state.get('dialogs').get('dialogs'), 'assignEmployeesToStages', 'stages', fromJS([])).toJS(),
    tasks: getDialogContextProp(state.get('dialogs').get('dialogs'), 'assignEmployeesToStages', 'tasks', fromJS([])).toJS(),
    employees,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchEmployees,
    hideDialog,
    showDialog,
    assignResourcesToTasks,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignEmployeesToStagesDialog);



// WEBPACK FOOTER //
// ./src/components/AssignEmployeesToStagesDialog/index.js